export default __webpack_public_path__ + "static/media/Countdown_GO.cdace546.svg";